<template>
  <div class="image-scroller">
    <div
      ref="scroller"
      class="image-scroller__scroller"
    >
      <div class="image-scroller__images">
        <div
          v-for="image in images"
          :key="image.source"
          class="image-scroller__image"
        >
          <image-loader
            :alt-text="image.altText"
            :source="image.source"
          />
        </div>
      </div>
    </div>

    <template v-if="images.length > 1">
      <button
        type="button"
        tabindex="-1"
        class="image-scroller__prev-button show-550-up"
        @click="scroll('previous')"
      >
        <span class="icon fa-arrow-left" />
      </button>

      <button
        type="button"
        tabindex="-1"
        class="image-scroller__next-button show-550-up"
        @click="scroll('next')"
      >
        <span class="icon fa-arrow-right" />
      </button>

      <div class="image-scroller__nav">
        <button
          v-for="(image, index) in images"
          :key="image.source"
          type="button"
          class="image-scroller__nav-item"
          :class="{
            'image-scroller__nav-item--active': activeIndex === index
          }"
          tabindex="-1"
          @click="scrollToIndex(index)"
        />
      </div>
    </template>
  </div>
</template>



<script>
  /*
    NOTE: If we wanted to handle infinite looping, check out this example:
    https://codepen.io/scottjehl/pen/jOEzYWw
  */

  export default {
    name: 'ImageScroller',

    props: {
      images: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        activeIndex: 0
      };
    },

    mounted() {
      this.mountedHandler();
    },

    methods: {
      mountedHandler() {
        const { scroller } = this.$refs;
        scroller.addEventListener('scroll', this.scrollHandler);
      },

      scroll(direction) {
        /*
          NOTE: Due to complex DOM interaction, this method
          isn't unit tested yet.
        */

        const { scroller } = this.$refs;
        const itemWidth = scroller.clientWidth;
        const scrollDistance = itemWidth;

        if (direction === 'previous') {
          if (scroller.scrollLeft === 0) {
            scroller.scrollTo({
              left: scroller.scrollWidth,
              behavior: 'smooth'
            });
          }

          else {
            scroller.scrollBy({
              left: scrollDistance * -1,
              behavior: 'smooth'
            });
          }
        }

        else if (scroller.scrollWidth - scroller.scrollLeft === scroller.clientWidth) {
          scroller.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }

        else {
          scroller.scrollBy({
            left: scrollDistance,
            behavior: 'smooth'
          });
        }
      },

      scrollHandler() {
        const { scroller } = this.$refs;
        const middlePoint = scroller.scrollLeft + (scroller.clientWidth / 2);

        const activeIndex = this.images.findIndex((image, index) => {
          const rightPoint = (index + 1) * scroller.clientWidth;
          return rightPoint > middlePoint;
        });

        this.activeIndex = activeIndex;
      },

      scrollToIndex(index) {
        const { scroller } = this.$refs;

        scroller.scrollTo({
          left: scroller.clientWidth * index,
          behavior: 'smooth'
        });
      }
    }
  };
</script>
